import { z } from 'zod';

export const linkTypeSchema = z.enum(['download', 'upload']);
export type LinkType = z.infer<typeof linkTypeSchema>;

export const publicLinkSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  fileId: z.string().uuid().nullable(),
  folderId: z.string().uuid().nullable(),
  linkType: linkTypeSchema,
  token: z.string(),
  hasPassword: z.boolean(),
  maxDownloads: z.number().int().nullable(),
  currentDownloads: z.number().int().default(0),
  maxUploads: z.number().int().nullable(),
  currentUploads: z.number().int().default(0),
  maxFileSize: z.number().int().nullable(),
  allowedExtensions: z.array(z.string()).nullable(),
  expiresAt: z.string().datetime().nullable(),
  isActive: z.boolean().default(true),
  createdAt: z.string().datetime(),
  lastAccessedAt: z.string().datetime().nullable(),
});

export type PublicLink = z.infer<typeof publicLinkSchema>;

export const createPublicLinkRequestSchema = z.object({
  fileId: z.string().uuid().optional(),
  folderId: z.string().uuid().optional(),
  linkType: linkTypeSchema,
  password: z.string().min(1).optional(),
  maxDownloads: z.number().int().positive().optional(),
  maxUploads: z.number().int().positive().optional(),
  maxFileSize: z.number().int().positive().optional(),
  allowedExtensions: z.array(z.string()).optional(),
  expiresAt: z.string().datetime().optional(),
});

export type CreatePublicLinkRequest = z.infer<typeof createPublicLinkRequestSchema>;

export const publicLinkInfoSchema = z.object({
  token: z.string(),
  linkType: linkTypeSchema,
  fileName: z.string().optional(),
  folderName: z.string().optional(),
  hasPassword: z.boolean(),
  expiresAt: z.string().datetime().nullable(),
  isExpired: z.boolean(),
  remainingDownloads: z.number().nullable(),
  remainingUploads: z.number().nullable(),
});

export type PublicLinkInfo = z.infer<typeof publicLinkInfoSchema>;

export const publicUploadRequestSchema = z.object({
  fileName: z.string().min(1).max(255),
  mimeType: z.string(),
  size: z.number().int().positive(),
  password: z.string().optional(),
});

export type PublicUploadRequest = z.infer<typeof publicUploadRequestSchema>;
